import {runInAction} from 'mobx';
import {formsStore} from '../../../stores/Form';

export const lockScreenKeyboardNavigation = (flag: boolean) => {
    if (formsStore.currentScreen) {
        runInAction(() => {
            formsStore.currentScreen.isNavigationBlocked = flag;
        });
    }
};
